import Vue from "vue";

/**
 * QRcode
 * How to use:
 * <qriously value="Hello World!" :size="200" />
 */
import VueQriously from "vue-qriously";

Vue.use(VueQriously);
